module.exports = __webpack_public_path__ + "img/schets-3.92c2ef2b.jpg";